<div class="container-list-item-dummy" [style]="'grid-template-columns: ' + gridColumnsWidths">
  <ng-content></ng-content>
</div>
